import { Button } from '@seen/ui'
import { IconRefresh } from '@tabler/icons-react'
import type { ReactNode } from 'react'

export function InboxReconcilePill({
  visible,
  onClick,
}: {
  visible: boolean
  onClick: () => void
}): ReactNode {
  if (!visible) {
    return null
  }
  return (
    <Button variant="status" color="blue" size="xs" onClick={onClick}>
      <IconRefresh className="size-3.5" />
      Refresh
    </Button>
  )
}
